import Crud from "../crud"
import { ADD_MUT, SET_MUT, UPDATE_MUT } from "@/store/mutation-types"
import Vue from "vue"
var crud = new Crud("skill-users")

const state = {
  ...crud.state,
}
const getters = {
  ...crud.getters,
}
const actions = {
  ...crud.actions,
}
const mutations = {
  [UPDATE_MUT]: (state, info) => {
    const index = state.data.findIndex((item) => item.id === info.id)
    state.data.splice(index, 1, info)
  },
  [ADD_MUT]: (state, data) => {
    const index = state.data.findIndex(
      (item) => item.skill.id === data.skill.id
    )
    state.data.splice(index, 1, data)
    Vue.set(state, "totalCount", state.totalCount + 1)
  },
  [SET_MUT]: (state, info) => {
    Vue.set(state, "data", info)
  },
  SET_TOTAL_COUNT(state, count) {
    Vue.set(state, "totalCount", count)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
